<template>
	<el-drawer class="recommend" :visible.sync="drawer" :before-close="handleClose" destroy-on-close :wrapperClosable="false" size="960px">
		<template slot="title">
			<p>
				<span>{{ title }}</span>
				<span class="fz-14 yx-color-text-regular ml-6">{{ desc }}</span>
			</p>
		</template>
		<div class="content flex">
			<div class="left">
				<div class="preview">
					<img src="@/assets/public/bg-chat.png" alt="" />
					<div class="shop-info">
						<product-box-mobile
							ref="productBoxMobile"
							:item="item"
							:custom="custom"
							:nowType="nowType"
							:customTitle="card_title"
							:default_img="default_img"
						></product-box-mobile>
					</div>
				</div>
				<div class="fz-14 yx-color-blue-6 mt-12 align-center">-预览图-</div>
			</div>
			<div class="right flex-1">
				<div class="select-type pb-26 flex flex-align-center">
					<div>小程序卡片样式</div>
					<div class="flex flex-align-center mt-4 ml-16">
						<el-radio v-model="radio" :label="1" @change="switchFun">指定商品展示</el-radio>
						<el-radio v-model="radio" :label="0" @change="switchFun">自定义</el-radio>
					</div>
				</div>
				<template v-if="custom">
					<div class="card-title fz-14 flex flex-align-center">
						<p class="mr-14 nowrap">卡片标题</p>
						<el-input type="text" v-model="card_title" maxlength="30" show-word-limit placeholder="请输入"></el-input>
					</div>
					<div class="fz-14 flex mt-20">
						<p class="mr-28">分享图</p>
						<div>
							<uploadImg @saveCardLink="saveCardLink" :default_img="default_img" ref="uploadImg" class="upload-img"></uploadImg>
							<p class="fz-12 yx-color-blue-6 mt-10"> 只能上传jpg/png文件，建议尺寸为5:4 </p>
						</div>
					</div>
				</template>
				<template v-else>
					<div class="select-box">
						<h4 class="mb-16">选择商品作为卡片主图</h4>
						<goods-select
							ref="goodsSelect"
							:options="list"
							:remote="nowType === 2"
							@change="changeItem"
							:platformId="platformId"
							:share_type="type"
							:selectValue="item.product_name"
						></goods-select>
					</div>
					<div class="pt-16 shop-box" v-if="item.product_id">
						<p class="yx-color-blue-6 fz-12">已选该商品为分享图, 可在上方搜索/选择框更换商品</p>
						<div class="shop-item mt-8">
							<product-box :bg="true" ref="productBox" :item="item"></product-box>
						</div>
					</div>
				</template>
				<div class="code-box mt-24 pt-24">
					<h4>微信扫描推广码</h4>
					<div class="mt-16 flex flex-align-center">
						<div class="qr-code">
							<img :src="qrCode" alt="" />
							<div class="yx-color-white invalid pointer" @click="createBtn" v-if="invalid">
								<i class="el-icon-refresh-right fz-20" style="margin-top: 50px"></i>
								<p class="fz-14 mt-4">刷新二维码</p>
							</div>
						</div>
						<div class="qr-desc ml-24 fz-12">
							<h5 class="fz-14 mb-8">分享步骤</h5>
							<p>1、微信扫描二维码</p>
							<p>2、点击页面右下角的‘立即分享’按钮</p>
							<p>3、选择微信达人招商分享到会话</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="bottom-btn">
			<el-button @click="handleClose">关 闭</el-button>
		</div>
	</el-drawer>
</template>
<script>
import { shareProduct } from '@/api/extenTecord';
import { wechatQrUrl } from '@/utils/common.js';
import productBox from '@/views/common/productBox';
import productBoxMobile from '@/views/common/productBoxMobile';
import uploadImg from '@/components/common/uploadImg';
import goodsSelect from '@/components/goodsSelect';
import { shareSelectCenter, upShareProduct } from '@/api/shopManage';
import { mapState } from 'vuex';
import { shareLib } from '@/api/shopManage';
export default {
	components: {
		productBox,
		productBoxMobile,
		goodsSelect,
		uploadImg,
	},
	props: {
		platformId: {
			type: [String, Number],
			default: () => {
				return '1';
			},
		},
		total: {
			type: [String, Number],
			default: () => {
				return '0';
			},
		},
	},
	computed: {
		...mapState(['vuex_userInfo']),
		custom({ radio }) {
			return !radio;
		},
		nowType({ radio, type }) {
			if (type) {
				if (radio) return 0; //商品组指定商品
				return 1; //商品组自定义
			} else {
				if (radio) return 2; //商品库指定商品
				return 3; //商品库自定义
			}
		},
		title({ type }) {
			let obj = {
				0: '选品中心推广',
				1: '推荐商品给达人',
			};
			return obj[type];
		},
		desc({ type, total }) {
			let obj = {
				0: `(共${total}个推广中状态的商品)`,
				1: `(共${this.list.length}个商品)`,
			};
			return obj[type];
		},
	},
	watch: {
		card_title: {
			handler() {
				this.shareRecord.custom = true;
				this.invalid = true;
			},
		},
		default_img: {
			handler() {
				this.shareRecord.custom = true;
				this.invalid = true;
			},
		},
	},
	data() {
		return {
			drawer: false,
			radio: 1,
			qrCode: '',
			list: [],
			item: {},
			card_title: '',
			type: 1,
			invalid: true,
			product_count: 0,
			handCardLink: '',
			group_id: '',
			default_img: '',
			shareRecord: {
				custom: true,
				appoint: true,
			},
			pic: '',
			shareImg: 'https://cdn.chaoyongbushou.com/wx/20220809/1660044085426-WechatIMG159.png',
			share_id: '',
		};
	},
	methods: {
		show(list, type, group_id = '') {
			this.group_id = group_id;
			this.radio = type;
			this.type = type;
			this.list = list;
			this.item = list[0] || {};
			this.card_title = !type ? `${this.vuex_userInfo.team_name}｜ 选品中心` : '';
			this.default_img = !type ? this.shareImg : '';
			if (type) return this.publicShare();
			this.shareSelectCenter();
		},
		handleClose() {
			this.default_img = '';
			this.invalid = true;
			this.shareRecord = {
				custom: true,
				appoint: true,
			};
			this.drawer = false;
		},
		async publicShare() {
			const { platformId: platform_id, group_id } = this;
			let productIds = this.list.map(item => item.product_id).join(',');
			let params = {
				share_type: '1',
				product_ids: productIds,
				group_id,
				platform_id,
			};
			params.product_id = this.item.product_id;
			params.share_style = 0;
			const { code, data } = await shareProduct(params);
			if (code === 0) {
				this.drawer = true;
				this.share_id = data.share_id;
				this.shareRecord.appoint = false;
				this.invalid = false;
				this.qrCode = wechatQrUrl(data.share_id);
			}
		},
		async publicFun() {
			const { platformId: platform_id, default_img, card_title } = this;
			let params = { platform_id, product_id: '' };
			params.pic = default_img;
			params.title = card_title;
			params.share_style = 1;
			const {
				code,
				data: { product_count, share_id },
			} = await shareLib(params);
			if (code === 0) {
				if (this.total == '0' || product_count == '0') return this.$message.warning('商品库暂无推广中商品，无法公开选品。');
				this.product_count = product_count;
				this.shareRecord.custom = false;
				this.drawer = true;
				this.invalid = false;
				this.qrCode = wechatQrUrl(share_id);
				this.share_id = share_id;
			}
		},
		async upShareProduct() {
			const { platformId: platform_id, nowType, default_img, card_title, share_id } = this;
			let params = { platform_id, share_id };
			if (nowType === 0) {
				params.product_id = this.item.product_id;
				params.share_style = 0;
			} else if (nowType === 1) {
				params.pic = default_img;
				params.title = card_title;
				params.share_style = 1;
				if (!params.title) return this.$message.error('请填写卡片标题');
				if (!params.pic) return this.$message.error('请选择分享图');
			} else if (nowType === 2) {
				if (!this.item.product_id) return this.$message.error('请选择商品');
				params.product_id = this.item.product_id;
				params.share_style = 0;
			} else if (nowType === 3) {
				params.pic = default_img;
				params.title = card_title;
				params.share_style = 1;
				if (!params.title) return this.$message.error('请填写卡片标题');
				if (!params.pic) return this.$message.error('请选择分享图');
			}
			const { code, data } = await upShareProduct(params);
			if (code === 0) {
				if (nowType === 0 || nowType === 2) {
					this.shareRecord.appoint = false;
					this.shareRecord.custom = true;
				} else {
					this.shareRecord.custom = false;
					this.shareRecord.appoint = true;
				}
				this.qrCode = wechatQrUrl(data.share_id);
				this.$message.success('小程序卡片设置已保存，请重新扫码');
				this.invalid = false;
			}
		},
		changeItem(e, obj) {
			if (JSON.stringify(this.item) !== JSON.stringify(obj)) (this.shareRecord.appoint = true), (this.invalid = true);
			this.item = obj;
		},
		switchFun() {
			const { type, nowType } = this;
			if (!type) {
				this.default_img = this.pic || '';
			}
			if (nowType === 0 || nowType === 2) {
				this.invalid = this.shareRecord.appoint;
			} else {
				this.invalid = this.shareRecord.custom;
			}
		},
		async shareSelectCenter() {
			const { code, data } = await shareSelectCenter({ platform_id: this.platformId });
			if (code !== 0) return;
			this.default_img = data.pic || this.shareImg;
			this.pic = data.pic;
			this.card_title = data.title || this.card_title;
			this.publicFun();
		},
		saveCardLink(val) {
			this.default_img = val;
		},
		createBtn() {
			this.upShareProduct();
		},
	},
};
</script>
<style lang="less" scoped>
.recommend {
	.content {
		padding: 24px;
		.left {
			width: 374px;
			.preview {
				position: relative;
				.shop-info {
					position: absolute;
					top: 175px;
					left: 75px;
				}
			}
		}
		.right {
			margin-left: 41px;
			.select-box {
				/deep/ .el-select__caret {
					color: @color-text-regular;
					font-weight: 600;
				}
			}
			.code-box {
				border-top: 1px solid #eaebf0;
				.qr-code {
					position: relative;
					width: 160px;
					height: 160px;
					.invalid {
						text-align: center;
						width: 100%;
						height: 100%;
						position: absolute;
						top: 0;
						left: 0;
						background: rgba(0, 0, 0, 0.7);
					}
				}
				.qr-desc {
					p {
						color: #4e596a;
						margin-bottom: 4px;
					}
					.btn-code {
						/deep/ .el-button--small {
							padding: 0px 26px;
						}
					}
				}
			}
		}
	}
	.bottom-btn {
		background-color: #fff;
		border-top: 1px solid #eee;
		text-align: right;
		padding: 14px 24px;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
	}
	.upload-img {
		/deep/ .el-upload--picture-card {
			background-color: #fff;
		}
	}
}
</style>
